import { render, staticRenderFns } from "./Ringing.vue?vue&type=template&id=65f1cc9e&scoped=true&"
import script from "./Ringing.vue?vue&type=script&lang=js&"
export * from "./Ringing.vue?vue&type=script&lang=js&"
import style0 from "./Ringing.vue?vue&type=style&index=0&id=65f1cc9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f1cc9e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VBtn,VIcon,VImg,VProgressLinear})
